"use client";

import Link from "next/link";
import { COMPANY_PHONE_TEXT, COMPANY_LOCATION, HEADER_MENUS } from "../../utils/constants";
import SocialMedias from "../layout/SocialMedias";
import { useEffect, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
// import path from "path";

const Header = () => {
  const [navMenu, setNavMenu] = useState(false);
  const [subMenu, setSubMenu] = useState(null);
  const pathname = usePathname();
  const hiddenPath = ["/login"];

  useEffect(() => {
    console.log("pathname", pathname);
    setNavMenu(false);
  }, [pathname]);

  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleMenu = () => {
    setNavMenu(!navMenu);

    setActiveDropdown(null);
    console.log("activeDropdown", activeDropdown);
  };

  const handleDropdown = (index) => {
    console.log("hello");
    setSubMenu((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    const onScroll = () => {
      const body = document.body;

      if (!hiddenPath.includes(pathname) && !pathname.startsWith("/admin")) {
        if ((window.innerWidth <= 760 && window.scrollY >= 0) || window.scrollY >= 40) {
          body.classList.add("header-fixed");
        } else {
          body.classList.remove("header-fixed");
        }
      } else {
        body.classList.remove("header-fixed");
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); // run once on mount

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [pathname]);

  if (!hiddenPath.includes(pathname) && !pathname.startsWith("/admin")) {
    return (
      <>
        <header>
          <section className="top">
            <div className="container">
              <div className="col-1-1 flex center-left color-white">
                <div className="logo flex center-center ">
                  <Link
                    href="/"
                    onClick={() => {
                      setTimeout(() => setNavMenu(false), 300);
                    }}
                  >
                    <div className="flex mar-12">
                      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.38338 16.1772C2.84281 9.59472 2 8.91916 2 6.5C2 3.18628 4.68628 0.5 8 0.5C11.3137 0.5 14 3.18628 14 6.5C14 8.91916 13.1572 9.59472 8.61662 16.1772C8.31866 16.6076 7.68131 16.6076 7.38338 16.1772ZM8 9C9.38072 9 10.5 7.88072 10.5 6.5C10.5 5.11928 9.38072 4 8 4C6.61928 4 5.5 5.11928 5.5 6.5C5.5 7.88072 6.61928 9 8 9Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </Link>
                  <p className="p-14 font-mont">{COMPANY_LOCATION}</p>
                </div>

                <div className="mar-l-a flex  center-center" style={{ gap: "20px" }}>
                <Link href="/contact-us" rel="noreferrer">
                  <p className="p-18 color-light-blue font-barlow f-w-400 t-t-u">
                    Contact us
                  </p> 
                  </Link>
                  <p className="p-14 font-mont f-w-300">{COMPANY_PHONE_TEXT[0]}</p>

                   <Link href="/login" rel="noreferrer">
                    <p className="" style={{
                      color:"#71b2b0"
                    }}>Login</p>
                  </Link>
                </div>
              </div>
            </div>
          </section>

          <div className="bottom">
            <div className="container">
              <div className="col-1-1 flex center-left row">
                <div className="logo">
                  <Link
                    href="/"
                    // onClick={() => {
                    //   setTimeout(() => setNavMenu(false), 300);
                    // }}
                  >
                    <div className="flex center-left">
                      <img src="/images/header/Link.png" alt="icon" height="70px" />
                    </div>
                  </Link>
                </div>
                <div className="right">
                  <div
                    className="col-1-1 flex top-right"
                    style={{
                      paddingTop: "12px",
                    }}
                  >
                    <SocialMedias />
                  </div>

                  <div
                    className="menuToggle"
                    style={{
                      padding: "10px",
                    }}
                    onClick={toggleMenu}
                  >
                    {navMenu ? (
                      <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 6L18 18M6 18L18 6" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    ) : (
                      <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 6H20M4 12H20M4 18H20" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    )}
                  </div>

                  <div className={`nav ${navMenu ? "active" : ""}`}>
                    <ul className="  flex top-right">
                      {HEADER_MENUS.map((menu, index) => (
                        <div key={index} className="sb   flex center-left">
                          <li>
                            <div className="menu-link">
                              <div
                                className={`${pathname === menu.slug ? "activeMenu" : ""}`}
                                style={{
                                  width: "100%",
                                }}
                              >
                                {/* <Link href={menu.slug}>{menu.title}</Link> */}

                                <Link href={menu.slug}>
                                  {menu.title}

                                </Link>
                              </div>
                              {menu.sub ? (
                                <div className="icon  color-white" onClick={() => handleDropdown(index)}>
                                  <div className="svg">
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        transform: subMenu === index ? "rotate(180deg)" : "rotate(0deg)",
                                        transition: "transform 0.25s ease",
                                      }}
                                    >
                                      <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>

                            {!!menu.sub?.length && (
                              <ul className={` ${subMenu === index ? "activeDropdown" : ""}`}>
                                {menu.sub.map((submenu, subIndex) => (
                                  <li key={subIndex}>
                                    <Link href={submenu.slug} className={`${pathname === submenu.slug ? "subMenu-active" : ""}`}>
                                      {submenu.title}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        </div>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </>
    );
  }
};

export default Header;
